import { SVGPureIcon } from "@/ui";
import { aigcFormStore } from "../store";
import { aigcBGMStore } from "../store/bgm-list";
import Tooltip from "@/ui/tooltip";
import { observer } from "mobx-react-lite";
import { request } from "@/common";
import { HelpOther } from "@/common/helper";

const isFavorite = (item) => {
  return item.marks.some(mark => mark.key === 'favorite')
}

const BGMItem = ({ item, isActive, size = 'normal', onClick }: {
  item: typeof aigcFormStore.listData.musicMap.bgms[number],
  isActive: boolean,
  size: 'normal' | 'mini',
  onClick: (e: React.MouseEvent<HTMLLIElement, MouseEvent>, item: typeof aigcFormStore.listData.musicMap.bgms[number]) => void
}) => {

  const onFav = async (e) => {
    e.nativeEvent.stopImmediatePropagation();
    e.stopPropagation()
    const isFav = isFavorite(item);
    const res = await request.post('/video/bgm/mark?appsource=so', {
      bgm_id: item.id,
      mark: 'favorite',
      state: isFav ? -1 : 1,
    }).catch(e => {
      HelpOther.toast('网络连接超时，稍后再试', 'warning')
      throw e
    })
    if (res.msg !== 'ok') {
      HelpOther.toast(`${isFav ? '取消' : ''}收藏失败，请稍后重试`, 'error')
      return
    }
    HelpOther.toast(isFav ? '取消成功' : '收藏成功', 'success')

    aigcFormStore.toggleBGMMarks(item)
  }

  return (<li
    key={item.id}
    id={item.id}
    className={[
      "aigc-selector-border  aspect-square group relative cursor-pointer !before:-inset-2px transition-colors duration-300 list-none flex gap-12px items-center",
      !!(item.voice_url && item.id !== 'auto') ? "aigc-bgm-item" : '',
      isActive ? 'is-active' : '',
    ].join(' ')}
    onClick={(e) => onClick(e, item)}
  >
    <div onClick={(e) => {
      if (!item.voice_url) {
        return
      }
      e.nativeEvent.stopImmediatePropagation();
    }}
      className="group relative rounded-8px overflow-hidden"
      style={{
        border: '2px solid transparent',
      }}
    >
      <img
        className=" rounded-8px pointer-events-none object-cover transition-colors duration-300 size-full"
        src={item.cover}
      />
      <h4 className={[
        'absolute m-0 pointer-events-none rounded-[0_0_8px_8px] backdrop-filter backdrop-blur-4px font-bold bg-[rgba(0,0,0,.65)] flex justify-center items-center h-36px text-[#fff] font-normal truncate text-16px right-0 bottom-0 left-0',
        item.voice_url && item.id !== 'auto' ? 'group-hover:opacity-0 ' : '',
        aigcBGMStore.playingID === item.id ? 'opacity-0' : ''
      ].join(' ')
      }
      >{item.title}</h4>
      {
        !!(item.voice_url && item.id !== 'auto') &&
        <div className={[
          "z-2 justify-center flex group-hover:translate-y-0 transition-transform duration-300 transform translate-y-100px absolute bottom-0 left-0 right-0",
          aigcBGMStore.playingID === item.id ? 'translate-y-0' : '',
          size === 'normal' ? 'gap-12px mb-10px' : 'gap-4px mb-6px px-6px'
        ].join(' ')}>
          <Tooltip title={isFavorite(item) ? '取消收藏' : '收藏'}>
            <button onClick={onFav} className="flex items-center justify-center transition-colors duration-300 cursor-pointer size-30px rounded-6px bg-[rgba(0,0,0,.5)] hover:bg-[rgba(0,0,0,.7)]">
              {
                isFavorite(item) ?
                  <SVGPureIcon key={'full'} size={16} name='star_2_full' className="flip-scale-2-hor-top text-[#FFA144]" /> :
                  <SVGPureIcon key={'empty'} size={16} name='star_2' className="flip-scale-2-hor-top text-[#fff]" />
              }
            </button>
          </Tooltip>
          <button
            onClick={(e) => { e.nativeEvent.stopImmediatePropagation(); e.stopPropagation(); aigcBGMStore.onPlay(item) }}
            className={[
              'mouse-active-translate h-30px transition-colors duration-300 cursor-pointer flex items-center justify-center text-[#fff] font-500 aspect-[30/47] rounded-6px bg-gradient-to-r from-[#7774FF] via-[#017FFD] to-[#01B1FD] hover:(bg-white/20 bg-blend-overlay)',
              size === 'mini' ? 'w-70px' : 'w-74px'
            ].join(' ')}>
            {
              aigcBGMStore.playingID === item.id ?
                <>
                  <SVGPureIcon
                    className="flex z-10 mr-1px" color='#fff' size={18} name='pause'
                  />试听中</> :
                <>
                  <SVGPureIcon
                    className="hidden group-hover:flex z-10 mr-2px" color='#fff' size={18} name='play'
                  />试听
                </>
            }
          </button>
        </div>
      }
    </div>

    {(aigcBGMStore.playingID === item.id && item.voice_url) &&
      <div className="flex items-center justify-center absolute right-1px top-1px w-30px h-30px bg-[#E1051B]"
        style={{ borderRadius: '0 6px 0 8px', margin: '1px 1px 0 0' }}>
        <img className="w-20px h-20px" src='https://p2.ssl.qhimg.com/t110b9a93015637df5f4a1ddf82.gif' />
      </div>
    }
  </li>)
}

export default observer(BGMItem)